import { useEffect, useState } from "react";
import classes from "./Profile.module.css";
import CommonButton from "../ui/CommonButton/CommonButton";
import { useNavigate, useParams } from "react-router-dom";
import { env } from "../../constants/env";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import ProfileDetails from "../ProfileDetails/ProfileDetails";

const Profile = () => {
  const navigate = useNavigate();

  const [labData, setLabData] = useState(null);
  const [error, setError] = useState(null);
  const { user } = useAuth();

  const { labId: paramLabId } = useParams();
  const labId = paramLabId || user?.labId;
  const userRole = user?.role;

  useEffect(() => {
    const fetchLab = async () => {
      try {
        const res = await axios.get(`${env.kataApiUrl}/api/profile/${labId}`);
        setLabData(res.data);
      } catch (err) {
        setError("Failed to fetch lab");
      }
    };

    if (labId) {
      fetchLab();
    }
  }, [labId]);

  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!labData) return <div>Loading lab profile...</div>;

  return (
    <div
      className={`${classes.wrapper} ${paramLabId ? classes.fromParams : ""}`}
    >
      <div className="d-flex align-items-center justify-content-between w-100 mb-4">
        <h2 className="m-0">Profile</h2>
        {userRole !== "MINISTRY" && (
          <CommonButton
            title="Edit lab"
            className={classes.buttonStyle}
            onClick={() => navigate("edit-profile")}
          />
        )}
      </div>
      <ProfileDetails labData={labData} />
    </div>
  );
};

export default Profile;
